module.exports = __webpack_public_path__ + "static/media/wifiIcon.42e06ae5.svg";